import React, { Component }  from 'react'

export default class Checkbox extends Component {
  render() {
    return (
      <label className="checkbox-container">
        <input
          ref={this.props.checkboxRef}
          id={`${this.props.value}_checkbox`}
          name={`${this.props.value}_checkbox`}
          type="checkbox"
          aria-describedby={this.props.ariaDescribedby}
          checked={this.props.checked}
          onChange={this.props.onChange}
          data-atid={`${this.props.dataAtId}_${this.props.value}_checkbox`}
        />
        <span className="checkmark"></span>
        <div id={`${this.props.value}_checkbox_info`} htmlFor={`${this.props.value}_checkbox`} tabIndex="-1">{this.props.info}</div>
			</label>
    );
  }
}